import Axios from 'axios';
import { getUrlParam } from '@/scripts/utils';

const baseUrl = 'https://us-central1-gucci-20-games.cloudfunctions.net/';
// const userId = getUrlParam('userId');
const userName = getUrlParam('userName');
const userId = getUrlParam('userId') || '3217a383-99c8-4416-a665-cfc51f859d2d';

export default {
  async getUserData({ commit }) {
    await Axios.get(`${baseUrl}game/getUserEpilogue/${userId}`).then((response) => {
      commit('SET_USER_DATA', { ...response.data, userName });
    }).catch(() => {
      commit('SET_USER_DATA', { score: 0, userName: getUrlParam('userName'), scoreRange: [] });
    });
  },

  async saveUserScore({ dispatch }, score) {
    const response = await Axios.get(`${baseUrl}/game/updateScoreEpilogue/${userId}/${score}`);

    if (response && response.data) {
      await dispatch('getUserData');
    }
  },
};
